"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flatAvailabilityToClassName = exports.flatAvailabilityToText = void 0;
const Flat_enums_1 = require("./Flat.enums");
function flatAvailabilityToText(availability) {
    switch (availability) {
        case Flat_enums_1.FlatAvailability.Available:
            return "Dostępne";
        case Flat_enums_1.FlatAvailability.Reserved:
            return "Rezerwacja";
        case Flat_enums_1.FlatAvailability.Sold:
            return "Sprzedane";
        default:
            return "";
    }
}
exports.flatAvailabilityToText = flatAvailabilityToText;
function flatAvailabilityToClassName(availability) {
    switch (availability) {
        case Flat_enums_1.FlatAvailability.Available:
            return "available";
        case Flat_enums_1.FlatAvailability.Reserved:
            return "reserved";
        case Flat_enums_1.FlatAvailability.Sold:
            return "sold";
        default:
            return "";
    }
}
exports.flatAvailabilityToClassName = flatAvailabilityToClassName;
//# sourceMappingURL=Flat.helpers.js.map